export default {
  data() {
    return {
      nowSecMixinTimerId: null,
      nowSec: Date.now() / 1000,
    };
  },

  created() {
    this.nowSecMixinTimerId = setInterval(this._NowSecMixin_updateTime, 1000);
  },

  beforeDestroy() {
    if(this.nowSecMixinTimerId !== null) {
      clearInterval(this.nowSecMixinTimerId);
      this.nowSecMixinTimerId = null;
    }
  },

  methods: {
    _NowSecMixin_updateTime() {
      this.nowSec = Date.now() / 1000;
    },
  },
};
